import { LOCALES, setLocale, useLocale, useT } from '~/i18n';

interface Props {
  className?: string;
}

/**
 * ES | EN. Dos botones y no un `<select>`: son dos opciones, caben en la barra,
 * y se cambian con un toque en el teléfono. Mismo cromo que "Salir": es ajuste
 * de la barra, no una acción de la página.
 *
 * Cada botón se anuncia con el nombre del idioma EN ese idioma ("English",
 * "Español"): quien no entiende el idioma actual tiene que poder encontrar el
 * suyo.
 */
export default function LocaleSwitcher({ className = 'shell__locale' }: Props) {
  const locale = useLocale();
  const t = useT('common');

  return (
    <div className={className} role="group" aria-label={t.language.label}>
      {LOCALES.map((option) => (
        <button
          key={option}
          type="button"
          lang={option}
          className="shell__locale-option"
          aria-pressed={option === locale}
          aria-label={option === 'es' ? t.language.esName : t.language.enName}
          onClick={() => setLocale(option)}
        >
          {option === 'es' ? t.language.es : t.language.en}
        </button>
      ))}
    </div>
  );
}
